<template>
  <div class="base-button-rectangle">
    <slot/>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.base-button-rectangle {
  flex-shrink: 0;
  width: 100%;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  overflow: hidden;
  border: solid var(--color-white-1) 1px;
  white-space: nowrap;
  cursor: pointer;
}
</style>
